import { Image, Menu } from "antd";
import React from "react";
import { SIDEBAR_ROUTES } from "../../routes/routesLinking";
import { useLocation } from "wouter";

const AdminSidebar = (props) => {
  const [location] = useLocation();
  const orderItems = SIDEBAR_ROUTES[props.role] || [];

  // Determine the active menu item based on the current path
  const activeKey =
    orderItems.find((item) => location.startsWith(item.label.props.to))?.key ||
    "1";

  return (
    <>
      <div
        className={`mx-auto my-4 ${
          !props.collapsed ? "w-[70px]" : "max-w-[90%]"
        }`}
      >
        <Image src="/assets/alp.svg" preview={false} />
      </div>
      <Menu
        theme="light"
        className="text-base text-left mt-2"
        mode="inline"
        selectedKeys={[activeKey]} // Use selectedKeys instead of defaultSelectedKeys
        items={orderItems}
      />
    </>
  );
};

export default AdminSidebar;
